import React, { useState } from "react";
import "./ReLoASection.scss";
import { useNavigate } from "react-router-dom";

const ReLoASection = ({ tabs, defaultTab = 0 }) => {
  const [activeTab, setActiveTab] = useState(defaultTab);
  const Navigate = useNavigate();
  const handleDiscover = (event, button) => {
    if (button?.link) {
      Navigate(button.link);
      return;
    }
    Navigate("/creators", {
      state: {
        collection: event.collectionName,
        address: event.collectionId,
        description: event.description || "",
      },
    });
  };

  return (
    <section className="tabs-section">
      <div className="tabs-nav">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={activeTab === index ? "active" : ""}
            onClick={() => setActiveTab(index)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="tabs-content">
        <h2>{tabs[activeTab].title}</h2>
        <p>{tabs[activeTab].content}</p>

        {tabs[activeTab].button && (
          <button
            className={`tabs-cta ${
              tabs[activeTab].button.variant === "link" ? "tabs-cta--link" : ""
            }`}
            onClick={(event) => handleDiscover(event, tabs[activeTab].button)}
          >
            {tabs[activeTab].button.text}
          </button>
        )}
      </div>
    </section>
  );
};

export default ReLoASection;
